const FetchGoalProgressActionsTypes = {
  FETCH_GOAL_PROGRESS_REQUEST: 'FETCH_GOAL_PROGRESS_REQUEST',
  FETCH_GOAL_PROGRESS_SUCCESS: 'FETCH_GOAL_PROGRESS_SUCCESS',
  FETCH_GOAL_PROGRESS_FAILURE: 'FETCH_GOAL_PROGRESS_FAILURE',
} as const;

export default { ...FetchGoalProgressActionsTypes };
